import { render, staticRenderFns } from "./CompGeneralTopCardDropdown.vue?vue&type=template&id=2bb492f8&scoped=true"
import script from "./CompGeneralTopCardDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./CompGeneralTopCardDropdown.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompGeneralTopCardDropdown.vue?vue&type=style&index=0&id=2bb492f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb492f8",
  null
  
)

export default component.exports